import React, { useState, useRef, useEffect } from "react";
import { HeaderMain, SelectAccountMain } from "../customer/styles/HeaderStyles";
import {
  SearchButton,
  SearchClean,
  SearchInputMain,
} from "./styles/SearchStyle";
// import SelectDate from "./SelectDate";
import {
  CleanButton,
  DateMain,
  DateStyleBtn,
  DateWrapper,
} from "./styles/SelectDateStyle";
import ClearIcon from "@mui/icons-material/Clear";
import SelectDropDown from "./SelectDropDown";
import { IconButton } from "@mui/material";
import search from "../../../assets/images/search.svg";
import calendar from "../../../assets/images/calendar.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const SharedHeaders = ({
  Placeholder = "",
  SearchInputValue = "",
  setSearchInputValue = () => {},
  SelectedAccountType = "",
  setSelectedAccountType = () => {},
  HasAccountType = true,
  SelectedDateCallback = "",
  setSelectedDateCallback = () => {},
}) => {
  const Showplaceholder = Placeholder || "Search Messages";
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const datepickerRef = useRef(null);

  //  ================= Search  =================

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleButtonClick = () => {
    setSearchInputValue(searchText);
  };
  const CleanHandleClick = () => {
    setSearchInputValue("");
    setSearchText("");
  };
  //  ================= End Search  =================

  //  =================  Account Type  =================

  const handleChange = (selectedOption) => {
    let SelectedValue;
    if (selectedOption?.value === "business") {
      SelectedValue = "basic_customer";
    } else if ("regular") {
      SelectedValue = "regular";
    }
    setSelectedOption(selectedOption);
    setSelectedAccountType(SelectedValue);
  };
  const options = [
    { value: "regular", label: "Regular" },
    { value: "business", label: "Business" },
  ];
  const CleanhandleDateClick = () => {
    setSelectedOption(null);
    setSelectedAccountType("");
  };

  //  =================  End Account Type  =================

  //  =================   Date Popup  =================

  const handleDateClick = () => {
    setShowDatePicker(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
    const formattedDate = moment(date).format("DD/MM/YYYY");
    setSelectedDateCallback(formattedDate);
  };

  const handleClickOutside = (event) => {
    if (
      datepickerRef.current &&
      !datepickerRef.current.contains(event.target)
    ) {
      setShowDatePicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const CleanHandleDateClick = () => {
    setSelectedDateCallback("");
  };

  //  =================  End Date Popup  =================

  return (
    <>
      <HeaderMain>
        <SearchInputMain>
          <img src={search} alt="search" />
          <input
            type="text"
            placeholder={Showplaceholder}
            value={searchText}
            onChange={handleInputChange}
          />
          {searchText && (
            <IconButton onClick={handleButtonClick}>
              <SearchButton />
            </IconButton>
          )}
          {searchText && (
            <IconButton onClick={CleanHandleClick}>
              <SearchClean />
            </IconButton>
          )}
        </SearchInputMain>

        {/* ==== Select Date ====   */}

        {/* <SelectDate /> */}
        <DateMain>
          <DateStyleBtn onClick={handleDateClick}>
            <img src={calendar} alt="calendar" />
            {!SelectedDateCallback ? "Select Date" : SelectedDateCallback}
          </DateStyleBtn>
          {SelectedDateCallback && (
            <CleanButton onClick={CleanHandleDateClick}>
              <ClearIcon />
            </CleanButton>
          )}
        </DateMain>
        {showDatePicker && (
          <DateWrapper className="customer__dateinputs" ref={datepickerRef}>
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              showPopperArrow={false}
              inline
            />
          </DateWrapper>
        )}

        {/* ==== End Select Date ====   */}

        {HasAccountType && (
          <SelectAccountMain>
            {SelectedAccountType && (
              <CleanButton
                onClick={CleanhandleDateClick}
                className="select_account_clean"
              >
                <ClearIcon />
              </CleanButton>
            )}
            <SelectDropDown
              options={options}
              selectedOption={selectedOption}
              handleChange={handleChange}
              placeholder="Select Account"
            />
          </SelectAccountMain>
        )}
      </HeaderMain>
    </>
  );
};

export default SharedHeaders;
